import React from "react"
import tw from "twin.macro"

interface Props {
  inputValue: string
  name: string
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void
  handleKeyUp: (e: React.KeyboardEvent<HTMLInputElement>) => void
  handleFocus: () => Promise<void> | void
  placeholder: string
}

export const SearchInput = ({
  inputValue,
  placeholder,
  name,
  handleChange,
  handleKeyDown,
  handleKeyUp,
  handleFocus,
}: Props) => {
  return (
    <div tw="w-full relative flex items-center bg-white border rounded-full border-base-6 border-2 pl-14">
      <input
        tw="w-[85%] h-11 px-3 py-1 text-left text-md bg-transparent text-base-6 font-medium focus:outline-none overflow-hidden whitespace-nowrap overflow-ellipsis text-base-6"
        css={`&::placeholder {${tw`text-base-5`}`}
        data-testid={`${name}-input`}
        type="text"
        name={name}
        id={`${name}-id`}
        onFocus={handleFocus}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onKeyUp={handleKeyUp}
        value={inputValue}
        placeholder={placeholder}
        aria-label={inputValue}
      />
    </div>
  )
}
